import React, { Component, createRef } from 'react';

class CustomAudioPlayer extends Component {
    constructor(props) {
        super(props);
        this.audioRef = createRef();
        this.state = {
            isPlaying: false,
            progress: 0,
            duration: 0,
            volume: 1,
            seeking: false,
            muted: false
        };
    }

    componentDidMount() {
    }
    componentWillUnmount() {
    }

    handlePlayPause = () => {
        const audio = this.audioRef.current;
        if (!audio) return;
        if (this.state.isPlaying) {
            audio.pause();
        } else {
            audio.play();
        }
    }

    handleTimeUpdate = () => {
        if (!this.state.seeking) {
            const audio = this.audioRef.current;
            if (!audio) return;
            this.setState({ progress: audio.currentTime });
        }
    }

    handleLoadedMetadata = () => {
        const audio = this.audioRef.current;
        if (!audio) return;
        this.setState({ duration: audio.duration });
    }

    handleSeek = (e) => {
        const audio = this.audioRef.current;
        if (!audio) return;
        const bar = e.target;
        const percent = e.nativeEvent.offsetX / bar.offsetWidth;
        const seekTime = percent * this.state.duration;
        audio.currentTime = seekTime;
        this.setState({ progress: seekTime, seeking: false });
    }

    handleSeekMouseDown = () => {
        this.setState({ seeking: true });
    }

    handleSeekMouseUp = (e) => {
        this.handleSeek(e);
        this.setState({ seeking: false });
    }

    handleVolume = (e) => {
        const audio = this.audioRef.current;
        if (!audio) return;
        const bar = e.target;
        const percent = e.nativeEvent.offsetX / bar.offsetWidth;
        audio.volume = percent;
        this.setState({ volume: percent });
    }

    handleVolumeIconClick = () => {
        const audio = this.audioRef.current;
        if (!audio) return;
        const newMuted = !this.state.muted;
        audio.muted = newMuted;
        this.setState({ muted: newMuted });
    }

    formatTime = (time) => {
        if (isNaN(time)) return '00:00';
        const m = Math.floor(time / 60);
        const s = Math.floor(time % 60);
        return `${m < 10 ? '0' + m : m}:${s < 10 ? '0' + s : s}`;
    }

    render() {
        const { src, poster, title } = this.props;
        const { isPlaying, progress, duration, volume, muted } = this.state;
        return (
            <div id="custom-audio-player" style={{ 
                position: 'relative', 
                width: '100%', 
                maxWidth: '100vw', 
                margin: '0 auto', 
                background: '#000', 
                borderRadius: 8, 
                overflow: 'hidden', 
                boxShadow: '0 2px 8px #0002',
                minHeight: '200px'
            }}>
                <div style={{
                    position: 'relative',
                    width: '100%',
                    paddingTop: '56.25%',
                    background: '#222'
                }}>
                    <img
                        src={poster}
                        alt="Thumbnail"
                        style={{ 
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            cursor: 'pointer'
                        }}
                        onClick={this.handlePlayPause}
                        onError={(e) => {
                            e.target.style.display = 'none';
                        }}
                    />
                </div>
                <audio
                    ref={this.audioRef}
                    src={src}
                    style={{ display: 'none' }}
                    onPlay={() => this.setState({ isPlaying: true })}
                    onPause={() => this.setState({ isPlaying: false })}
                    onTimeUpdate={this.handleTimeUpdate}
                    onLoadedMetadata={this.handleLoadedMetadata}
                    muted={muted}
                />
                {/* Nút play lớn ở giữa khi chưa play */}
                {!isPlaying &&
                    <button
                        onClick={this.handlePlayPause}
                        style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            background: 'rgba(0,0,0,0.7)',
                            border: 'none',
                            borderRadius: '50%',
                            width: '4.5rem',
                            height: '4.5rem',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            boxShadow: '0 2px 8px #0005',
                            cursor: 'pointer',
                            zIndex: 2,
                            padding: 0
                        }}
                    >
                        <svg width="2.5rem" height="2.5rem" viewBox="0 0 40 40" style={{ display: 'block' }}>
                            <polygon points="16,12 30,20 16,28" fill="#fff" />
                        </svg>
                    </button>
                }
                {/* Controls bar */}
                <div style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    background: 'rgba(20,20,20,0.95)',
                    display: 'flex',
                    alignItems: 'center',
                    padding: '0.7rem 3vw',
                    boxSizing: 'border-box',
                    gap: '0.7rem',
                    flexWrap: 'nowrap',
                    minHeight: '3.2rem',
                    overflow: 'hidden',
                    zIndex: 3
                }}>
                    {/* Play/Pause nhỏ */}
                    <button onClick={this.handlePlayPause} style={{ background: 'none', border: 'none', cursor: 'pointer', marginRight: '0.5rem', width: '2.2rem', height: '2.2rem', display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: '2.2rem', minHeight: '2.2rem' }}>
                        {isPlaying ? (
                            <svg width="1.7rem" height="1.7rem" fill="#fff" viewBox="0 0 24 24"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>
                        ) : (
                            <svg width="1.7rem" height="1.7rem" fill="#fff" viewBox="0 0 24 24"><polygon points="5,3 19,12 5,21"/></svg>
                        )}
                    </button>
                    {/* Thời gian hiện tại */}
                    <span style={{ color: '#fff', fontSize: '0.95rem', minWidth: '2.2rem', textAlign: 'right', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{this.formatTime(progress)}</span>
                    {/* Progress bar */}
                    <div
                        style={{
                            flex: 1,
                            minWidth: 30,
                            maxWidth: '100vw',
                            height: '0.5rem',
                            background: '#444',
                            borderRadius: '0.25rem',
                            cursor: 'pointer',
                            position: 'relative',
                            margin: '0 0.5rem'
                        }}
                        onClick={this.handleSeek}
                        onMouseDown={this.handleSeekMouseDown}
                        onMouseUp={this.handleSeekMouseUp}
                    >
                        <div
                            style={{
                                width: duration ? `${(progress / duration) * 100}%` : '0%',
                                height: '100%',
                                background: '#00d8ff',
                                borderRadius: '0.25rem'
                            }}
                        />
                    </div>
                    {/* Thời gian tổng */}
                    <span style={{ color: '#fff', fontSize: '0.95rem', minWidth: '2.2rem', textAlign: 'left', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{this.formatTime(duration)}</span>
                    {/* Volume */}
                    <div style={{ display: 'flex', alignItems: 'center', marginLeft: '0.5rem', minWidth: 40 }}>
                        <button onClick={this.handleVolumeIconClick} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0, marginRight: '0.3rem', width: '1.7rem', height: '1.7rem', display: 'flex', alignItems: 'center', justifyContent: 'center', minWidth: '1.7rem', minHeight: '1.7rem' }}>
                            {muted ? (
                                // Icon mute: loa + gạch chéo
                                <svg width="1.4rem" height="1.4rem" fill="none" viewBox="0 0 24 24">
                                  <path d="M5 9v6h4l5 5V4l-5 5H5z" stroke="#fff" strokeWidth="2" strokeLinejoin="round"/>
                                  <line x1="21" y1="3" x2="3" y2="21" stroke="#fff" strokeWidth="2" strokeLinecap="round"/>
                                </svg>
                            ) : (
                                // Icon volume: loa
                                <svg width="1.4rem" height="1.4rem" fill="none" viewBox="0 0 24 24">
                                  <path d="M5 9v6h4l5 5V4l-5 5H5z" stroke="#fff" strokeWidth="2" strokeLinejoin="round"/>
                                </svg>
                            )}
                        </button>
                        <div
                            style={{ width: '3.5rem', height: '0.5rem', background: '#444', borderRadius: '0.25rem', cursor: 'pointer', position: 'relative', minWidth: 30 }}
                            onClick={this.handleVolume}
                        >
                            <div
                                style={{
                                    width: `${volume * 100}%`,
                                    height: '100%',
                                    background: '#00d8ff',
                                    borderRadius: '0.25rem'
                                }}
                            />
                        </div>
                    </div>
                </div>
                {/* Tên bài hát */}
                <div style={{
                    position: 'absolute',
                    top: '1.1rem',
                    left: '1.5rem',
                    color: '#fff',
                    fontWeight: 500,
                    fontSize: '1.1rem',
                    textShadow: '0 2px 8px #000a',
                    maxWidth: '80vw',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }}>{title || ''}</div>
            </div>
        );
    }
}

export default CustomAudioPlayer;
